var map = {
	"./nn/dictation/diktat-12.mp3": 83074,
	"./nn/dictation/diktat-13.mp3": 86618,
	"./nn/dictation/diktat-15.mp3": 36859,
	"./nn/dictation/diktat-16.mp3": 47366,
	"./nn/dictation/diktat-17.mp3": 91863,
	"./nn/dictation/diktat-19.mp3": 59502,
	"./nn/dictation/diktat-21.mp3": 57210,
	"./nn/dictation/diktat-24.mp3": 68004,
	"./nn/dictation/diktat-28.mp3": 43889,
	"./nn/dictation/diktat-35.mp3": 56944,
	"./nn/dictation/diktat-36.mp3": 79662,
	"./nn/dictation/diktat-38.mp3": 92129,
	"./nn/dictation/diktat-39.mp3": 29784,
	"./nn/dictation/diktat-intro.mp3": 79032,
	"./nn/intros/letterKnowledge-intro.mp3": 25259,
	"./nn/intros/oneMinute-intro.mp3": 37932,
	"./nn/intros/pd-intro.mp3": 37238,
	"./nn/intros/phonemeIsolation-klarte-oppgaver.mp3": 28422,
	"./nn/intros/phonemeIsolation-starter-intro.mp3": 99110,
	"./nn/intros/testen-er-ferdig.mp3": 34137,
	"./nn/intros/workingmemory-numbers-intro.mp3": 62222,
	"./nn/intros/workingmemory-words-intro.mp3": 75381,
	"./nn/nonwordRepetition/adult/test/1.mp3": 66827,
	"./nn/nonwordRepetition/adult/test/10.mp3": 50973,
	"./nn/nonwordRepetition/adult/test/11.mp3": 32330,
	"./nn/nonwordRepetition/adult/test/12.mp3": 6872,
	"./nn/nonwordRepetition/adult/test/13.mp3": 19590,
	"./nn/nonwordRepetition/adult/test/14.mp3": 54912,
	"./nn/nonwordRepetition/adult/test/15.mp3": 56795,
	"./nn/nonwordRepetition/adult/test/16.mp3": 95937,
	"./nn/nonwordRepetition/adult/test/2.mp3": 41683,
	"./nn/nonwordRepetition/adult/test/3.mp3": 96890,
	"./nn/nonwordRepetition/adult/test/4.mp3": 27716,
	"./nn/nonwordRepetition/adult/test/5.mp3": 88207,
	"./nn/nonwordRepetition/adult/test/6.mp3": 87978,
	"./nn/nonwordRepetition/adult/test/7.mp3": 65691,
	"./nn/nonwordRepetition/adult/test/8.mp3": 69078,
	"./nn/nonwordRepetition/adult/test/9.mp3": 72646,
	"./nn/nonwordRepetition/adult/trial/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 13279,
	"./nn/nonwordRepetition/adult/trial/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 67084,
	"./nn/nonwordRepetition/adult/trial/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 47178,
	"./nn/nonwordRepetition/adult/trial/Instructions for all tests/Intro-after-trail.mp3": 92186,
	"./nn/nonwordRepetition/adult/trial/Instructions for all tests/Intro-nonord-NN.mp3": 16176,
	"./nn/nonwordRepetition/adult/trial/exersices/ALL TRIAL if-correct.mp3": 76978,
	"./nn/nonwordRepetition/adult/trial/exersices/ALL-trialrepeat-the-word.mp3": 74278,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2-if-wrong.mp3": 81625,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2-if-wrongafter-10-sec.mp3": 12790,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2-unansweredafter-10-sec.mp3": 96116,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2.mp3": 11758,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3-after-10-sek-if-wrong.mp3": 21036,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3-if-wrong.mp3": 6756,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3-unanswered-after-10-sec.mp3": 87699,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3.mp3": 3625,
	"./nn/nonwordRepetition/adult/trial/exersices/Trial1-if-correct.mp3": 94585,
	"./nn/nonwordRepetition/adult/trial/exersices/Trial1-if-wrong.mp3": 98997,
	"./nn/nonwordRepetition/adult/trial/exersices/Trial1.mp3": 33745,
	"./nn/nonwordRepetition/adult/trial/exersices/trial1-after-10-sek-if-unanswered.mp3": 78463,
	"./nn/nonwordRepetition/adult/trial/exersices/trial1-after-10-sek-if-wrong.mp3": 16626,
	"./nn/nonwordRepetition/child/test/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 17723,
	"./nn/nonwordRepetition/child/test/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 18481,
	"./nn/nonwordRepetition/child/test/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 69866,
	"./nn/nonwordRepetition/child/test/Repeat-the-word-kan-du-seie-orde.mp3": 19896,
	"./nn/nonwordRepetition/child/test/nonord c 1.mp3": 68548,
	"./nn/nonwordRepetition/child/test/nonord-c-10.mp3": 34626,
	"./nn/nonwordRepetition/child/test/nonord-c-11.mp3": 45862,
	"./nn/nonwordRepetition/child/test/nonord-c-12.mp3": 60792,
	"./nn/nonwordRepetition/child/test/nonord-c-13.mp3": 40717,
	"./nn/nonwordRepetition/child/test/nonord-c-14.mp3": 49719,
	"./nn/nonwordRepetition/child/test/nonord-c-15.mp3": 24297,
	"./nn/nonwordRepetition/child/test/nonord-c-16.mp3": 74623,
	"./nn/nonwordRepetition/child/test/nonord-c-17.mp3": 77758,
	"./nn/nonwordRepetition/child/test/nonord-c-2.mp3": 41814,
	"./nn/nonwordRepetition/child/test/nonord-c-3.mp3": 50778,
	"./nn/nonwordRepetition/child/test/nonord-c-4.mp3": 36388,
	"./nn/nonwordRepetition/child/test/nonord-c-5.mp3": 67141,
	"./nn/nonwordRepetition/child/test/nonord-c-6.mp3": 34584,
	"./nn/nonwordRepetition/child/test/nonord-c-7.mp3": 42583,
	"./nn/nonwordRepetition/child/test/nonord-c-8.mp3": 27403,
	"./nn/nonwordRepetition/child/test/nonord-c-9.mp3": 94952,
	"./nn/nonwordRepetition/child/trial/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 11669,
	"./nn/nonwordRepetition/child/trial/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 14529,
	"./nn/nonwordRepetition/child/trial/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 41632,
	"./nn/nonwordRepetition/child/trial/Intro-after-trial.mp3": 75311,
	"./nn/nonwordRepetition/child/trial/Repeat-the-word-kan-du-seie-orde.mp3": 10407,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL if-correct.mp3": 98398,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL-1-if-wrong-after-10-sec.mp3": 72341,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL-1-if-wrong.mp3": 25014,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL-1-unanswered-10-sec.mp3": 87941,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL1.mp3": 2438,
	"./nn/nonwordRepetition/distractions/1-NN-Klapp.mp3": 24375,
	"./nn/nonwordRepetition/distractions/2-2-GKOLpGmm.mp3": 57013,
	"./nn/nonwordRepetition/distractions/2-NN-Farger .mp3": 93052,
	"./nn/nonwordRepetition/distractions/3-NN-Tall .mp3": 17651,
	"./nn/nonwordRepetition/distractions/Animals.mp3": 3523,
	"./nn/nonwordRepetition/distractions/Name items in order from biggest to smallest.mp3": 80582,
	"./nn/nonwordRepetition/distractions/Name items with the same shape.mp3": 89719,
	"./nn/nonwordRepetition/distractions/Name items.mp3": 20931,
	"./nn/nonwordRepetition/distractions/items in the same color.mp3": 6627,
	"./nn/nonwordRepetition/youth/test/1-Y.mp3": 11762,
	"./nn/nonwordRepetition/youth/test/10-Y.mp3": 65628,
	"./nn/nonwordRepetition/youth/test/11-Y.mp3": 12160,
	"./nn/nonwordRepetition/youth/test/12-Y.mp3": 95337,
	"./nn/nonwordRepetition/youth/test/13-Y.mp3": 79286,
	"./nn/nonwordRepetition/youth/test/14-Y.mp3": 7242,
	"./nn/nonwordRepetition/youth/test/15-Y.mp3": 1009,
	"./nn/nonwordRepetition/youth/test/16-Y.mp3": 61684,
	"./nn/nonwordRepetition/youth/test/2-Y.mp3": 16238,
	"./nn/nonwordRepetition/youth/test/3-Y.mp3": 75619,
	"./nn/nonwordRepetition/youth/test/4-Y.mp3": 64361,
	"./nn/nonwordRepetition/youth/test/5-Y.mp3": 77590,
	"./nn/nonwordRepetition/youth/test/6-Y.mp3": 93054,
	"./nn/nonwordRepetition/youth/test/7-Y.mp3": 85295,
	"./nn/nonwordRepetition/youth/test/8-Y.mp3": 58952,
	"./nn/nonwordRepetition/youth/test/9-Y.mp3": 43144,
	"./nn/nonwordRepetition/youth/test/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 33268,
	"./nn/nonwordRepetition/youth/test/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 92474,
	"./nn/nonwordRepetition/youth/test/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 18601,
	"./nn/nonwordRepetition/youth/test/Repeat-the-wordmain-tasks.mp3": 5332,
	"./nn/nonwordRepetition/youth/trial/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 83759,
	"./nn/nonwordRepetition/youth/trial/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 15658,
	"./nn/nonwordRepetition/youth/trial/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 94026,
	"./nn/nonwordRepetition/youth/trial/Instructions for all tests/Intro-after-trail.mp3": 59907,
	"./nn/nonwordRepetition/youth/trial/Repeat-the-wordmain-tasks.mp3": 18452,
	"./nn/nonwordRepetition/youth/trial/exersices/ALL TRIAL-if-correct-after-10-sec.mp3": 35195,
	"./nn/nonwordRepetition/youth/trial/exersices/ALL-trialrepeat-the-word.mp3": 18771,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2-if-wrong.mp3": 74420,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2-if-wrongafter-10-sec.mp3": 54963,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2-unansweredafter-10-sec.mp3": 24719,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2.mp3": 85281,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3 unanswered-after-10-sec.mp3": 44772,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3-if-wrong-after-10-sec.mp3": 29968,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3-if-wrong.mp3": 52618,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3.mp3": 99305,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1-answered-after-10-sec.mp3": 26821,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1-if-wrong-after-10-sec.mp3": 71372,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1.mp3": 24710,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1if-wrong.mp3": 89472,
	"./nn/nonwordRepetition/youth/trial/exersices/if-correct.mp3": 57712,
	"./nn/phonemeDeletion/brev-b.mp3": 24634,
	"./nn/phonemeDeletion/brev.mp3": 15146,
	"./nn/phonemeDeletion/broed-b.mp3": 84839,
	"./nn/phonemeDeletion/bru-r.mp3": 45975,
	"./nn/phonemeDeletion/bry-r.mp3": 63338,
	"./nn/phonemeDeletion/drap-d.mp3": 31690,
	"./nn/phonemeDeletion/foere-f.mp3": 36057,
	"./nn/phonemeDeletion/foere.mp3": 95638,
	"./nn/phonemeDeletion/gaas-g.mp3": 6312,
	"./nn/phonemeDeletion/gris-g.mp3": 98793,
	"./nn/phonemeDeletion/gris.mp3": 16165,
	"./nn/phonemeDeletion/klatre-t.mp3": 16842,
	"./nn/phonemeDeletion/klede-k.mp3": 45394,
	"./nn/phonemeDeletion/laas-s.mp3": 47873,
	"./nn/phonemeDeletion/lekse-k.mp3": 84532,
	"./nn/phonemeDeletion/loff-f.mp3": 62500,
	"./nn/phonemeDeletion/maal-m.mp3": 81145,
	"./nn/phonemeDeletion/malt-l.mp3": 55808,
	"./nn/phonemeDeletion/sel-l.mp3": 70889,
	"./nn/phonemeDeletion/sel.mp3": 39315,
	"./nn/phonemeDeletion/skyl-l.mp3": 32236,
	"./nn/phonemeDeletion/sport-p.mp3": 81775,
	"./nn/phonemeDeletion/trygg-t.mp3": 24397,
	"./nn/phonemeIsolation/ends_with_e.mp3": 37438,
	"./nn/phonemeIsolation/ends_with_i.mp3": 38140,
	"./nn/phonemeIsolation/ends_with_k.mp3": 24628,
	"./nn/phonemeIsolation/ends_with_n.mp3": 11123,
	"./nn/phonemeIsolation/ends_with_o.mp3": 77689,
	"./nn/phonemeIsolation/ends_with_p.mp3": 10079,
	"./nn/phonemeIsolation/ends_with_r.mp3": 82663,
	"./nn/phonemeIsolation/ends_with_t.mp3": 66075,
	"./nn/phonemeIsolation/ends_with_u.mp3": 14369,
	"./nn/phonemeIsolation/ends_with_y.mp3": 80437,
	"./nn/phonemeIsolation/starts_with_b.mp3": 25792,
	"./nn/phonemeIsolation/starts_with_e.mp3": 77217,
	"./nn/phonemeIsolation/starts_with_g.mp3": 2566,
	"./nn/phonemeIsolation/starts_with_h.mp3": 67505,
	"./nn/phonemeIsolation/starts_with_i.mp3": 64563,
	"./nn/phonemeIsolation/starts_with_k.mp3": 71579,
	"./nn/phonemeIsolation/starts_with_l.mp3": 16907,
	"./nn/phonemeIsolation/starts_with_oe.mp3": 94165,
	"./nn/phonemeIsolation/starts_with_s.mp3": 61997,
	"./nn/phonemeIsolation/starts_with_v.mp3": 44434,
	"./nn/rapidNaming/rapidNaming-intro1.mp3": 17375,
	"./nn/rapidNaming/rapidNaming-intro2-old.mp3": 42200,
	"./nn/rapidNaming/rapidNaming-intro2.mp3": 18467,
	"./nn/rapidNaming/rapidNaming-intro3-old.mp3": 96213,
	"./nn/rapidNaming/rapidNaming-intro3.mp3": 20455,
	"./nn/rapidNaming/rapidNaming-intro4-old.mp3": 48734,
	"./nn/rapidNaming/rapidNaming-intro4.mp3": 27166,
	"./nn/rapidNaming/rapidNaming-intro5.mp3": 51731,
	"./nn/sentencememory/adult/test/A1.mp3": 27913,
	"./nn/sentencememory/adult/test/A10.mp3": 99492,
	"./nn/sentencememory/adult/test/A11.mp3": 51700,
	"./nn/sentencememory/adult/test/A12.mp3": 52895,
	"./nn/sentencememory/adult/test/A13.mp3": 27330,
	"./nn/sentencememory/adult/test/A14.mp3": 20154,
	"./nn/sentencememory/adult/test/A15.mp3": 21577,
	"./nn/sentencememory/adult/test/A2.mp3": 54996,
	"./nn/sentencememory/adult/test/A3.mp3": 4845,
	"./nn/sentencememory/adult/test/A4.mp3": 10167,
	"./nn/sentencememory/adult/test/A5.mp3": 57868,
	"./nn/sentencememory/adult/test/A6.mp3": 41967,
	"./nn/sentencememory/adult/test/A7.mp3": 11397,
	"./nn/sentencememory/adult/test/A8.mp3": 14150,
	"./nn/sentencememory/adult/test/A9.mp3": 33718,
	"./nn/sentencememory/adult/trial/TASK 1 if-wrong.mp3": 86628,
	"./nn/sentencememory/adult/trial/TASK 1.mp3": 54241,
	"./nn/sentencememory/adult/trial/TASK 2 if wrong.mp3": 38193,
	"./nn/sentencememory/adult/trial/TASK 2.mp3": 26079,
	"./nn/sentencememory/child/test/grade2-4/ST1.mp3": 36577,
	"./nn/sentencememory/child/test/grade2-4/ST10.mp3": 589,
	"./nn/sentencememory/child/test/grade2-4/ST11.mp3": 84499,
	"./nn/sentencememory/child/test/grade2-4/ST12.mp3": 20442,
	"./nn/sentencememory/child/test/grade2-4/ST2.mp3": 71234,
	"./nn/sentencememory/child/test/grade2-4/ST3.mp3": 45019,
	"./nn/sentencememory/child/test/grade2-4/ST4.mp3": 10655,
	"./nn/sentencememory/child/test/grade2-4/ST5.mp3": 75354,
	"./nn/sentencememory/child/test/grade2-4/ST6.mp3": 80509,
	"./nn/sentencememory/child/test/grade2-4/ST7.mp3": 54142,
	"./nn/sentencememory/child/test/grade2-4/ST8.mp3": 732,
	"./nn/sentencememory/child/test/grade2-4/ST9.mp3": 48583,
	"./nn/sentencememory/child/test/grade5-7/MT1.mp3": 52563,
	"./nn/sentencememory/child/test/grade5-7/MT10.mp3": 84584,
	"./nn/sentencememory/child/test/grade5-7/MT11.mp3": 89413,
	"./nn/sentencememory/child/test/grade5-7/MT12.mp3": 62658,
	"./nn/sentencememory/child/test/grade5-7/MT2.mp3": 70554,
	"./nn/sentencememory/child/test/grade5-7/MT3.mp3": 80414,
	"./nn/sentencememory/child/test/grade5-7/MT4.mp3": 16985,
	"./nn/sentencememory/child/test/grade5-7/MT5.mp3": 35820,
	"./nn/sentencememory/child/test/grade5-7/MT6.mp3": 7129,
	"./nn/sentencememory/child/test/grade5-7/MT7.mp3": 22044,
	"./nn/sentencememory/child/test/grade5-7/MT9.mp3": 95449,
	"./nn/sentencememory/child/trial/grade2-4/Instructions-after-trail.mp3": 54731,
	"./nn/sentencememory/child/trial/grade2-4/Instructions.mp3": 70688,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3": 19731,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3": 44404,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL.mp3": 97387,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3": 73407,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3": 66478,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL.mp3": 1618,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-correct.mp3": 60605,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-wrong.mp3": 70858,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL.mp3": 30304,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-correct.mp3": 33708,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-wrong.mp3": 98628,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL.mp3": 49610,
	"./nn/sentencememory/youth/test/Y1.mp3": 18372,
	"./nn/sentencememory/youth/test/Y10.mp3": 8938,
	"./nn/sentencememory/youth/test/Y11.mp3": 30566,
	"./nn/sentencememory/youth/test/Y12.mp3": 17501,
	"./nn/sentencememory/youth/test/Y13.mp3": 84873,
	"./nn/sentencememory/youth/test/Y14.mp3": 97815,
	"./nn/sentencememory/youth/test/Y15.mp3": 91752,
	"./nn/sentencememory/youth/test/Y2.mp3": 72275,
	"./nn/sentencememory/youth/test/Y3.mp3": 742,
	"./nn/sentencememory/youth/test/Y4.mp3": 33755,
	"./nn/sentencememory/youth/test/Y5.mp3": 53786,
	"./nn/sentencememory/youth/test/Y6.mp3": 82475,
	"./nn/sentencememory/youth/test/Y7.mp3": 40670,
	"./nn/sentencememory/youth/test/Y8.mp3": 78849,
	"./nn/sentencememory/youth/test/Y9.mp3": 14332,
	"./nn/sentencememory/youth/trail/TRIAL 1-if-wrong.mp3": 37715,
	"./nn/sentencememory/youth/trail/TRIAL 1.mp3": 3776,
	"./nn/sentencememory/youth/trail/TRIAL 2-if-wrong.mp3": 41893,
	"./nn/sentencememory/youth/trail/TRIAL 2.mp3": 92918,
	"./nn/spoonerism/correct-1.mp3": 32838,
	"./nn/spoonerism/correct-2.mp3": 37366,
	"./nn/spoonerism/correct-3.mp3": 53101,
	"./nn/spoonerism/incorrect-1.mp3": 75628,
	"./nn/spoonerism/incorrect-2.mp3": 23874,
	"./nn/spoonerism/incorrect-3.mp3": 74833,
	"./nn/spoonerism/intro-end.mp3": 99186,
	"./nn/spoonerism/intro.mp3": 11203,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-1.mp3": 69426,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-10.mp3": 79660,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-11.mp3": 35942,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-12.mp3": 52539,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-13.mp3": 38858,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-14.mp3": 46398,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-15.mp3": 98973,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-16.mp3": 18287,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-17.mp3": 68999,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-18.mp3": 72382,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-2.mp3": 80860,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-3.mp3": 33629,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-4.mp3": 93168,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-5.mp3": 80054,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-6.mp3": 87375,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-7.mp3": 43053,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-8.mp3": 81881,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-9.mp3": 512,
	"./nn/spoonerism/norming/grade6-7/trail/Instructions-after-trial.mp3": 79374,
	"./nn/spoonerism/norming/grade6-7/trail/Instructions.mp3": 18606,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-both-correct.mp3": 34786,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-both-wrong.mp3": 62732,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-one-correct.mp3": 40559,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1.mp3": 70764,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-both-correct.mp3": 44877,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-both-wrong.mp3": 86387,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-one-correct.mp3": 85646,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2.mp3": 71509,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-both-correct.mp3": 57783,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-both-wrong.mp3": 77752,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-one-correct.mp3": 9589,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3.mp3": 55311,
	"./nn/spoonerism/proveoppgave-1.mp3": 62306,
	"./nn/spoonerism/proveoppgave-2.mp3": 80591,
	"./nn/spoonerism/proveoppgave-3.mp3": 14947,
	"./nn/spoonerism/spoonerism-task (1).mp3": 90044,
	"./nn/spoonerism/spoonerism-task (10).mp3": 9821,
	"./nn/spoonerism/spoonerism-task (11).mp3": 44991,
	"./nn/spoonerism/spoonerism-task (2).mp3": 27314,
	"./nn/spoonerism/spoonerism-task (3).mp3": 40199,
	"./nn/spoonerism/spoonerism-task (4).mp3": 82105,
	"./nn/spoonerism/spoonerism-task (5).mp3": 88603,
	"./nn/spoonerism/spoonerism-task (6).mp3": 68266,
	"./nn/spoonerism/spoonerism-task (7).mp3": 75621,
	"./nn/spoonerism/spoonerism-task (8).mp3": 18093,
	"./nn/spoonerism/spoonerism-task (9).mp3": 73011,
	"./nn/spoonerism/unk-spoonerism-task ().mp3": 22176,
	"./nn/workingmemory_numbers/wmTrial-numbers-1.mp3": 7760,
	"./nn/workingmemory_numbers/wmTrial-numbers-2.mp3": 62075,
	"./nn/workingmemory_numbers/workingmemory-numbers-1.mp3": 97743,
	"./nn/workingmemory_numbers/workingmemory-numbers-10.mp3": 51656,
	"./nn/workingmemory_numbers/workingmemory-numbers-11.mp3": 80613,
	"./nn/workingmemory_numbers/workingmemory-numbers-12.mp3": 58884,
	"./nn/workingmemory_numbers/workingmemory-numbers-2.mp3": 55577,
	"./nn/workingmemory_numbers/workingmemory-numbers-3.mp3": 16439,
	"./nn/workingmemory_numbers/workingmemory-numbers-4.mp3": 76638,
	"./nn/workingmemory_numbers/workingmemory-numbers-5.mp3": 72634,
	"./nn/workingmemory_numbers/workingmemory-numbers-6.mp3": 61628,
	"./nn/workingmemory_numbers/workingmemory-numbers-7.mp3": 86834,
	"./nn/workingmemory_numbers/workingmemory-numbers-8.mp3": 68792,
	"./nn/workingmemory_numbers/workingmemory-numbers-9.mp3": 79673,
	"./nn/workingmemory_words/stop.mp3": 74953,
	"./nn/workingmemory_words/wmTrial-words-1.mp3": 72947,
	"./nn/workingmemory_words/wmTrial-words-2.mp3": 1356,
	"./nn/workingmemory_words/workingmemory-words-1.mp3": 87690,
	"./nn/workingmemory_words/workingmemory-words-10.mp3": 97715,
	"./nn/workingmemory_words/workingmemory-words-11.mp3": 20319,
	"./nn/workingmemory_words/workingmemory-words-12.mp3": 2499,
	"./nn/workingmemory_words/workingmemory-words-2.mp3": 83579,
	"./nn/workingmemory_words/workingmemory-words-3.mp3": 15409,
	"./nn/workingmemory_words/workingmemory-words-4.mp3": 47473,
	"./nn/workingmemory_words/workingmemory-words-5.mp3": 61606,
	"./nn/workingmemory_words/workingmemory-words-6.mp3": 96873,
	"./nn/workingmemory_words/workingmemory-words-7.mp3": 7709,
	"./nn/workingmemory_words/workingmemory-words-8.mp3": 60671,
	"./nn/workingmemory_words/workingmemory-words-9.mp3": 41614,
	"./no/dictation/diktat-0.mp3": 75572,
	"./no/dictation/diktat-1.mp3": 75785,
	"./no/dictation/diktat-10.mp3": 97268,
	"./no/dictation/diktat-11.mp3": 15235,
	"./no/dictation/diktat-12.mp3": 15110,
	"./no/dictation/diktat-13.mp3": 18428,
	"./no/dictation/diktat-14.mp3": 4112,
	"./no/dictation/diktat-15.mp3": 17067,
	"./no/dictation/diktat-16.mp3": 3889,
	"./no/dictation/diktat-17.mp3": 48656,
	"./no/dictation/diktat-18.mp3": 55981,
	"./no/dictation/diktat-19.mp3": 33071,
	"./no/dictation/diktat-2.mp3": 39671,
	"./no/dictation/diktat-20.mp3": 24045,
	"./no/dictation/diktat-21.mp3": 76165,
	"./no/dictation/diktat-22.mp3": 61662,
	"./no/dictation/diktat-23.mp3": 97062,
	"./no/dictation/diktat-24.mp3": 40726,
	"./no/dictation/diktat-25.mp3": 65745,
	"./no/dictation/diktat-26.mp3": 61153,
	"./no/dictation/diktat-27.mp3": 35246,
	"./no/dictation/diktat-28.mp3": 20594,
	"./no/dictation/diktat-29.mp3": 21320,
	"./no/dictation/diktat-3.mp3": 96378,
	"./no/dictation/diktat-30.mp3": 21277,
	"./no/dictation/diktat-31.mp3": 70286,
	"./no/dictation/diktat-32.mp3": 97538,
	"./no/dictation/diktat-33.mp3": 70169,
	"./no/dictation/diktat-34.mp3": 88649,
	"./no/dictation/diktat-35.mp3": 57780,
	"./no/dictation/diktat-36.mp3": 43221,
	"./no/dictation/diktat-37.mp3": 73193,
	"./no/dictation/diktat-38.mp3": 15238,
	"./no/dictation/diktat-39.mp3": 5744,
	"./no/dictation/diktat-4.mp3": 36527,
	"./no/dictation/diktat-5.mp3": 94601,
	"./no/dictation/diktat-6.mp3": 73342,
	"./no/dictation/diktat-7.mp3": 63249,
	"./no/dictation/diktat-8.mp3": 23485,
	"./no/dictation/diktat-9.mp3": 92752,
	"./no/dictation/diktat-intro.mp3": 27129,
	"./no/intros/NonWOrdInstruction.mp3": 73448,
	"./no/intros/NonWord-Intro-AFTER-trail-exercises.mp3": 15261,
	"./no/intros/SM_Intro-AFTER-trial.mp3": 24924,
	"./no/intros/letterKnowledge-intro.mp3": 88068,
	"./no/intros/oneMinute-intro.mp3": 32532,
	"./no/intros/pd-intro.mp3": 36334,
	"./no/intros/phonemeIsolation-klarte-oppgaver.mp3": 46537,
	"./no/intros/phonemeIsolation-starter-intro.mp3": 3676,
	"./no/intros/setningsminne-intro.mp3": 9957,
	"./no/intros/testen-er-ferdig.mp3": 49306,
	"./no/intros/workingmemory-numbers-intro.mp3": 93119,
	"./no/intros/workingmemory-words-intro.mp3": 86570,
	"./no/nonwordRepetition/adult/test/1.mp3": 31540,
	"./no/nonwordRepetition/adult/test/10.mp3": 17360,
	"./no/nonwordRepetition/adult/test/11.mp3": 26871,
	"./no/nonwordRepetition/adult/test/12.mp3": 93446,
	"./no/nonwordRepetition/adult/test/13.mp3": 46477,
	"./no/nonwordRepetition/adult/test/14.mp3": 98545,
	"./no/nonwordRepetition/adult/test/15.mp3": 26740,
	"./no/nonwordRepetition/adult/test/16.mp3": 54753,
	"./no/nonwordRepetition/adult/test/2.mp3": 19389,
	"./no/nonwordRepetition/adult/test/3.mp3": 47460,
	"./no/nonwordRepetition/adult/test/4.mp3": 32122,
	"./no/nonwordRepetition/adult/test/5.mp3": 36823,
	"./no/nonwordRepetition/adult/test/6.mp3": 25529,
	"./no/nonwordRepetition/adult/test/7.mp3": 52358,
	"./no/nonwordRepetition/adult/test/8.mp3": 40993,
	"./no/nonwordRepetition/adult/test/9.mp3": 96152,
	"./no/nonwordRepetition/adult/test/Si-ordet-en-gang-til.mp3": 96338,
	"./no/nonwordRepetition/adult/trial/Si-ordet-en-gang-til.mp3": 16649,
	"./no/nonwordRepetition/adult/trial/Trial 1(3)-kan-du-si-ordet-en-gang-til2.mp3": 65694,
	"./no/nonwordRepetition/adult/trial/Trial1-if-correct.mp3": 16774,
	"./no/nonwordRepetition/adult/trial/Trial1-if-wrong.mp3": 96906,
	"./no/nonwordRepetition/adult/trial/Trial1.mp3": 80479,
	"./no/nonwordRepetition/adult/trial/trial 1(3)-after-10-sek-if-correct.mp3": 226,
	"./no/nonwordRepetition/adult/trial/trial1-after-10-sek-if-unanswered.mp3": 86693,
	"./no/nonwordRepetition/adult/trial/trial1-after-10-sek-if-wrong.mp3": 8501,
	"./no/nonwordRepetition/child/test/Si-ordet-en-gang-til.mp3": 87340,
	"./no/nonwordRepetition/child/test/nonord-c-1.mp3": 85446,
	"./no/nonwordRepetition/child/test/nonord-c-10.mp3": 53579,
	"./no/nonwordRepetition/child/test/nonord-c-11.mp3": 87825,
	"./no/nonwordRepetition/child/test/nonord-c-12.mp3": 85133,
	"./no/nonwordRepetition/child/test/nonord-c-13.mp3": 45751,
	"./no/nonwordRepetition/child/test/nonord-c-14.mp3": 13028,
	"./no/nonwordRepetition/child/test/nonord-c-15.mp3": 86512,
	"./no/nonwordRepetition/child/test/nonord-c-16.mp3": 88829,
	"./no/nonwordRepetition/child/test/nonord-c-17.mp3": 50364,
	"./no/nonwordRepetition/child/test/nonord-c-2.mp3": 665,
	"./no/nonwordRepetition/child/test/nonord-c-3.mp3": 71154,
	"./no/nonwordRepetition/child/test/nonord-c-4.mp3": 19649,
	"./no/nonwordRepetition/child/test/nonord-c-5.mp3": 98239,
	"./no/nonwordRepetition/child/test/nonord-c-6.mp3": 56742,
	"./no/nonwordRepetition/child/test/nonord-c-7.mp3": 22158,
	"./no/nonwordRepetition/child/test/nonord-c-8.mp3": 94531,
	"./no/nonwordRepetition/child/test/nonord-c-9.mp3": 33879,
	"./no/nonwordRepetition/child/trial/Intro-AFTER-trail-exercises.mp3": 3123,
	"./no/nonwordRepetition/child/trial/Si-ordet-en-gang-til.mp3": 1574,
	"./no/nonwordRepetition/child/trial/TRIAL1-after-10-sek-if-wrong.mp3": 90926,
	"./no/nonwordRepetition/child/trial/trial-1-after10sec-if-they-dont-rememeber.mp3": 42628,
	"./no/nonwordRepetition/child/trial/trial1-if-correct.mp3": 68842,
	"./no/nonwordRepetition/child/trial/trial1-if-wrong.mp3": 51977,
	"./no/nonwordRepetition/child/trial/trial1.mp3": 74242,
	"./no/nonwordRepetition/distractions/1-4-adp9Bwg9.mp3": 9378,
	"./no/nonwordRepetition/distractions/1-Klapp (1).mp3": 48872,
	"./no/nonwordRepetition/distractions/2-Fargene (1).mp3": 60360,
	"./no/nonwordRepetition/distractions/3-Tall (1).mp3": 44594,
	"./no/nonwordRepetition/distractions/4 things that has the same shape.mp3": 7672,
	"./no/nonwordRepetition/distractions/Animals.mp3": 15469,
	"./no/nonwordRepetition/distractions/Items in same color.mp3": 65718,
	"./no/nonwordRepetition/distractions/Name items in order from biggest to smallest.mp3": 15958,
	"./no/nonwordRepetition/distractions/Name items.mp3": 64747,
	"./no/nonwordRepetition/youth/test/1-Y.mp3": 84139,
	"./no/nonwordRepetition/youth/test/10-Y.mp3": 29282,
	"./no/nonwordRepetition/youth/test/11-Y.mp3": 57791,
	"./no/nonwordRepetition/youth/test/12-Y.mp3": 41965,
	"./no/nonwordRepetition/youth/test/13-Y.mp3": 3511,
	"./no/nonwordRepetition/youth/test/14-Y.mp3": 22976,
	"./no/nonwordRepetition/youth/test/15-Y.mp3": 79207,
	"./no/nonwordRepetition/youth/test/16-Y.mp3": 99673,
	"./no/nonwordRepetition/youth/test/2-Y.mp3": 56435,
	"./no/nonwordRepetition/youth/test/3-Y.mp3": 66177,
	"./no/nonwordRepetition/youth/test/4-Y.mp3": 57360,
	"./no/nonwordRepetition/youth/test/5-Y.mp3": 7937,
	"./no/nonwordRepetition/youth/test/6-Y.mp3": 77128,
	"./no/nonwordRepetition/youth/test/7-Y.mp3": 5206,
	"./no/nonwordRepetition/youth/test/8-Y.mp3": 6570,
	"./no/nonwordRepetition/youth/test/9-Y.mp3": 68457,
	"./no/nonwordRepetition/youth/test/Si-ordet-en-gang-til.mp3": 55619,
	"./no/nonwordRepetition/youth/trial/Intro-AFTER-trialexercises.mp3": 53032,
	"./no/nonwordRepetition/youth/trial/Si-ordet-en-gang-til.mp3": 98842,
	"./no/nonwordRepetition/youth/trial/Trial1-if-correct.mp3": 87739,
	"./no/nonwordRepetition/youth/trial/Trial1-if-wrong.mp3": 41884,
	"./no/nonwordRepetition/youth/trial/Trial1-kan-du-si-ordet-en-gang-til2.mp3": 13370,
	"./no/nonwordRepetition/youth/trial/Trial1.mp3": 41926,
	"./no/nonwordRepetition/youth/trial/trial1-after-10-sek-if-correct.mp3": 54724,
	"./no/nonwordRepetition/youth/trial/trial1-after-10-sek-if-unanswered.mp3": 73592,
	"./no/nonwordRepetition/youth/trial/trial1-after-10-sek-if-wrong.mp3": 55098,
	"./no/phonemeDeletion/brev-b.mp3": 58944,
	"./no/phonemeDeletion/brev.mp3": 18435,
	"./no/phonemeDeletion/bro-r.mp3": 38883,
	"./no/phonemeDeletion/bro.mp3": 9528,
	"./no/phonemeDeletion/broed-b.mp3": 22299,
	"./no/phonemeDeletion/broed.mp3": 12712,
	"./no/phonemeDeletion/brus-b.mp3": 22886,
	"./no/phonemeDeletion/bry-r.mp3": 30373,
	"./no/phonemeDeletion/bry.mp3": 94547,
	"./no/phonemeDeletion/dansk-k.mp3": 56495,
	"./no/phonemeDeletion/drap-d.mp3": 15087,
	"./no/phonemeDeletion/drap.mp3": 30510,
	"./no/phonemeDeletion/film-m.mp3": 78568,
	"./no/phonemeDeletion/foere-f.mp3": 85897,
	"./no/phonemeDeletion/foere.mp3": 55947,
	"./no/phonemeDeletion/gaas-g.mp3": 51302,
	"./no/phonemeDeletion/gaas.mp3": 92653,
	"./no/phonemeDeletion/gris-g.mp3": 488,
	"./no/phonemeDeletion/gris.mp3": 78063,
	"./no/phonemeDeletion/hans-s.mp3": 9511,
	"./no/phonemeDeletion/helst-l.mp3": 54136,
	"./no/phonemeDeletion/klaer-k.mp3": 19754,
	"./no/phonemeDeletion/klaer.mp3": 37546,
	"./no/phonemeDeletion/klart-t.mp3": 58187,
	"./no/phonemeDeletion/klatre-t.mp3": 82216,
	"./no/phonemeDeletion/klatre.mp3": 88523,
	"./no/phonemeDeletion/laas-s.mp3": 5670,
	"./no/phonemeDeletion/laas.mp3": 93711,
	"./no/phonemeDeletion/lekse-k.mp3": 83418,
	"./no/phonemeDeletion/lekse.mp3": 43967,
	"./no/phonemeDeletion/loff-f.mp3": 77800,
	"./no/phonemeDeletion/loff.mp3": 77347,
	"./no/phonemeDeletion/maal-m.mp3": 58408,
	"./no/phonemeDeletion/malt-l.mp3": 68840,
	"./no/phonemeDeletion/malt.mp3": 76788,
	"./no/phonemeDeletion/mars-r.mp3": 54178,
	"./no/phonemeDeletion/pris-p.mp3": 70770,
	"./no/phonemeDeletion/ris-r.mp3": 56130,
	"./no/phonemeDeletion/sel-l.mp3": 88504,
	"./no/phonemeDeletion/sel.mp3": 92960,
	"./no/phonemeDeletion/ser-r.mp3": 14113,
	"./no/phonemeDeletion/skyll-l.mp3": 24516,
	"./no/phonemeDeletion/skyll.mp3": 44569,
	"./no/phonemeDeletion/spoer-p.mp3": 24709,
	"./no/phonemeDeletion/sport-p.mp3": 25380,
	"./no/phonemeDeletion/sport.mp3": 38065,
	"./no/phonemeDeletion/stoev-s.mp3": 21735,
	"./no/phonemeDeletion/tap-p.mp3": 81833,
	"./no/phonemeDeletion/tekst-k.mp3": 88486,
	"./no/phonemeDeletion/trygg-t.mp3": 57647,
	"./no/phonemeDeletion/trygg.mp3": 96316,
	"./no/phonemeIsolation/ends_with_e.mp3": 80841,
	"./no/phonemeIsolation/ends_with_i.mp3": 35432,
	"./no/phonemeIsolation/ends_with_k.mp3": 95997,
	"./no/phonemeIsolation/ends_with_n.mp3": 8962,
	"./no/phonemeIsolation/ends_with_o.mp3": 57976,
	"./no/phonemeIsolation/ends_with_p.mp3": 25120,
	"./no/phonemeIsolation/ends_with_r.mp3": 16502,
	"./no/phonemeIsolation/ends_with_t.mp3": 13812,
	"./no/phonemeIsolation/ends_with_u.mp3": 62559,
	"./no/phonemeIsolation/ends_with_y.mp3": 34966,
	"./no/phonemeIsolation/starts_with_b.mp3": 96592,
	"./no/phonemeIsolation/starts_with_e.mp3": 70177,
	"./no/phonemeIsolation/starts_with_g.mp3": 51280,
	"./no/phonemeIsolation/starts_with_h.mp3": 18064,
	"./no/phonemeIsolation/starts_with_i.mp3": 36493,
	"./no/phonemeIsolation/starts_with_k.mp3": 54923,
	"./no/phonemeIsolation/starts_with_l.mp3": 37769,
	"./no/phonemeIsolation/starts_with_oe.mp3": 77773,
	"./no/phonemeIsolation/starts_with_s.mp3": 79672,
	"./no/phonemeIsolation/starts_with_v.mp3": 17740,
	"./no/rapidNaming/rapidNaming-intro1.mp3": 45152,
	"./no/rapidNaming/rapidNaming-intro2-old.mp3": 59693,
	"./no/rapidNaming/rapidNaming-intro2.mp3": 84391,
	"./no/rapidNaming/rapidNaming-intro3-old.mp3": 26837,
	"./no/rapidNaming/rapidNaming-intro3.mp3": 9680,
	"./no/rapidNaming/rapidNaming-intro4-old.mp3": 85841,
	"./no/rapidNaming/rapidNaming-intro4.mp3": 4437,
	"./no/rapidNaming/rapidNaming-intro5.mp3": 55257,
	"./no/sentencememory/adult/test/S-1.mp3": 44755,
	"./no/sentencememory/adult/test/S-10.mp3": 90751,
	"./no/sentencememory/adult/test/S-11.mp3": 58366,
	"./no/sentencememory/adult/test/S-12.mp3": 37088,
	"./no/sentencememory/adult/test/S-13.mp3": 76348,
	"./no/sentencememory/adult/test/S-14.mp3": 84423,
	"./no/sentencememory/adult/test/S-15.mp3": 6421,
	"./no/sentencememory/adult/test/S-2.mp3": 16379,
	"./no/sentencememory/adult/test/S-3.mp3": 70066,
	"./no/sentencememory/adult/test/S-4.mp3": 43346,
	"./no/sentencememory/adult/test/S-5.mp3": 94350,
	"./no/sentencememory/adult/test/S-6.mp3": 87148,
	"./no/sentencememory/adult/test/S-7.mp3": 42531,
	"./no/sentencememory/adult/test/S-8.mp3": 63194,
	"./no/sentencememory/adult/test/S-9.mp3": 67064,
	"./no/sentencememory/adult/trial/A TRIAL 1-if-correct.mp3": 90236,
	"./no/sentencememory/adult/trial/A TRIAL 1.mp3": 42314,
	"./no/sentencememory/adult/trial/A TRIAL 2-if-correct-kopi.mp3": 53652,
	"./no/sentencememory/adult/trial/A TRIAL 2-if-wrong.mp3": 99474,
	"./no/sentencememory/adult/trial/A TRIAL 2.mp3": 32793,
	"./no/sentencememory/adult/trial/A TRIAL1-If-wrong.mp3": 83044,
	"./no/sentencememory/adult/trial/Intro-AFTER-trial.mp3": 17128,
	"./no/sentencememory/adult/trial/Intro-Y-A.mp3": 63625,
	"./no/sentencememory/child/test/grade2-4/SM-ST-1.mp3": 20108,
	"./no/sentencememory/child/test/grade2-4/SM-ST-10.mp3": 58384,
	"./no/sentencememory/child/test/grade2-4/SM-ST-11.mp3": 80637,
	"./no/sentencememory/child/test/grade2-4/SM-ST-12 (2).mp3": 65350,
	"./no/sentencememory/child/test/grade2-4/SM-ST-12.mp3": 29049,
	"./no/sentencememory/child/test/grade2-4/SM-ST-2.mp3": 27489,
	"./no/sentencememory/child/test/grade2-4/SM-ST-3.mp3": 26951,
	"./no/sentencememory/child/test/grade2-4/SM-ST-4.mp3": 19902,
	"./no/sentencememory/child/test/grade2-4/SM-ST-5.mp3": 23039,
	"./no/sentencememory/child/test/grade2-4/SM-ST-6.mp3": 73251,
	"./no/sentencememory/child/test/grade2-4/SM-ST-7.mp3": 9127,
	"./no/sentencememory/child/test/grade2-4/SM-ST-8.mp3": 32414,
	"./no/sentencememory/child/test/grade2-4/SM-ST-9.mp3": 45005,
	"./no/sentencememory/child/test/grade5-7/SM-MT-1.mp3": 89209,
	"./no/sentencememory/child/test/grade5-7/SM-MT-10.mp3": 70046,
	"./no/sentencememory/child/test/grade5-7/SM-MT-11.mp3": 52271,
	"./no/sentencememory/child/test/grade5-7/SM-MT-12.mp3": 53147,
	"./no/sentencememory/child/test/grade5-7/SM-MT-2.mp3": 33608,
	"./no/sentencememory/child/test/grade5-7/SM-MT-3.mp3": 8075,
	"./no/sentencememory/child/test/grade5-7/SM-MT-4.mp3": 70159,
	"./no/sentencememory/child/test/grade5-7/SM-MT-5.mp3": 28278,
	"./no/sentencememory/child/test/grade5-7/SM-MT-6.mp3": 40635,
	"./no/sentencememory/child/test/grade5-7/SM-MT-7.mp3": 85147,
	"./no/sentencememory/child/test/grade5-7/SM-MT-8.mp3": 25315,
	"./no/sentencememory/child/test/grade5-7/SM-MT-9.mp3": 86799,
	"./no/sentencememory/child/trial/grade2-4/SM-ST-intro (1).mp3": 30075,
	"./no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3": 69882,
	"./no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3": 36627,
	"./no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL.mp3": 17388,
	"./no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3": 69625,
	"./no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3": 42343,
	"./no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL.mp3": 72926,
	"./no/sentencememory/child/trial/grade5-7/SM-MT-intro-AFTER-trial-exercise.mp3": 54903,
	"./no/sentencememory/child/trial/grade5-7/SM-MT-intro-mp3.mp3": 20031,
	"./no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-correct.mp3": 79541,
	"./no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-wrong.mp3": 66914,
	"./no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL.mp3": 86140,
	"./no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-correct.mp3": 88294,
	"./no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-wrong.mp3": 59305,
	"./no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL.mp3": 81096,
	"./no/sentencememory/test/SM-ST-1.mp3": 69723,
	"./no/sentencememory/test/SM-ST-10.mp3": 50182,
	"./no/sentencememory/test/SM-ST-11.mp3": 99330,
	"./no/sentencememory/test/SM-ST-12.mp3": 45445,
	"./no/sentencememory/test/SM-ST-2.mp3": 64209,
	"./no/sentencememory/test/SM-ST-3.mp3": 82816,
	"./no/sentencememory/test/SM-ST-4.mp3": 55340,
	"./no/sentencememory/test/SM-ST-5.mp3": 14623,
	"./no/sentencememory/test/SM-ST-6.mp3": 80627,
	"./no/sentencememory/test/SM-ST-7.mp3": 43945,
	"./no/sentencememory/test/SM-ST-8.mp3": 89345,
	"./no/sentencememory/test/SM-ST-9.mp3": 54389,
	"./no/sentencememory/test/grade2-4/SM-ST-1.mp3": 7905,
	"./no/sentencememory/test/grade2-4/SM-ST-10.mp3": 22483,
	"./no/sentencememory/test/grade2-4/SM-ST-11.mp3": 73639,
	"./no/sentencememory/test/grade2-4/SM-ST-12 (2).mp3": 38286,
	"./no/sentencememory/test/grade2-4/SM-ST-12.mp3": 48473,
	"./no/sentencememory/test/grade2-4/SM-ST-2.mp3": 39774,
	"./no/sentencememory/test/grade2-4/SM-ST-3.mp3": 32037,
	"./no/sentencememory/test/grade2-4/SM-ST-4.mp3": 3055,
	"./no/sentencememory/test/grade2-4/SM-ST-5.mp3": 34074,
	"./no/sentencememory/test/grade2-4/SM-ST-6.mp3": 41221,
	"./no/sentencememory/test/grade2-4/SM-ST-7.mp3": 29780,
	"./no/sentencememory/test/grade2-4/SM-ST-8.mp3": 49180,
	"./no/sentencememory/test/grade2-4/SM-ST-9.mp3": 49840,
	"./no/sentencememory/test/grade5-7/SM-MT-1.mp3": 73659,
	"./no/sentencememory/test/grade5-7/SM-MT-10.mp3": 62941,
	"./no/sentencememory/test/grade5-7/SM-MT-11.mp3": 75644,
	"./no/sentencememory/test/grade5-7/SM-MT-12.mp3": 50680,
	"./no/sentencememory/test/grade5-7/SM-MT-2.mp3": 7772,
	"./no/sentencememory/test/grade5-7/SM-MT-3.mp3": 42985,
	"./no/sentencememory/test/grade5-7/SM-MT-4.mp3": 32480,
	"./no/sentencememory/test/grade5-7/SM-MT-5.mp3": 51456,
	"./no/sentencememory/test/grade5-7/SM-MT-6.mp3": 13651,
	"./no/sentencememory/test/grade5-7/SM-MT-7.mp3": 84505,
	"./no/sentencememory/test/grade5-7/SM-MT-8.mp3": 12297,
	"./no/sentencememory/test/grade5-7/SM-MT-9.mp3": 7496,
	"./no/sentencememory/trial/SM-ST-O1-correct.mp3": 4055,
	"./no/sentencememory/trial/SM-ST-O1-wrong.mp3": 8960,
	"./no/sentencememory/trial/SM-ST-O1.mp3": 36511,
	"./no/sentencememory/trial/SM-ST-O2-correct.mp3": 46258,
	"./no/sentencememory/trial/SM-ST-O2-wrong.mp3": 1732,
	"./no/sentencememory/trial/SM-ST-O2.mp3": 41228,
	"./no/sentencememory/trial/grade2-4/SM-ST-intro (1).mp3": 27391,
	"./no/sentencememory/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3": 16190,
	"./no/sentencememory/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3": 20306,
	"./no/sentencememory/trial/grade2-4/SM-ST1-TRIAL.mp3": 17655,
	"./no/sentencememory/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3": 8249,
	"./no/sentencememory/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3": 48870,
	"./no/sentencememory/trial/grade2-4/SM-ST2-TRIAL.mp3": 59547,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL1-if-correct.mp3": 17806,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL1-if-wrong.mp3": 45529,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL1.mp3": 29804,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL2-if-correct.mp3": 5609,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL2-if-worng.mp3": 63162,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL2.mp3": 49484,
	"./no/sentencememory/trial/grade5-7/SM-MT-intro-AFTER-trial-exercise.mp3": 78764,
	"./no/sentencememory/trial/grade5-7/SM-MT-intro-mp3.mp3": 13875,
	"./no/sentencememory/youth/test/S-1-Y.mp3": 98343,
	"./no/sentencememory/youth/test/S-10-Y.mp3": 45122,
	"./no/sentencememory/youth/test/S-11-Y.mp3": 14628,
	"./no/sentencememory/youth/test/S-12-Y.mp3": 9764,
	"./no/sentencememory/youth/test/S-13-Y.mp3": 3805,
	"./no/sentencememory/youth/test/S-14-Y.mp3": 61454,
	"./no/sentencememory/youth/test/S-15-Y.mp3": 12820,
	"./no/sentencememory/youth/test/S-2-Y.mp3": 65659,
	"./no/sentencememory/youth/test/S-3-Y.mp3": 94262,
	"./no/sentencememory/youth/test/S-4-Y.mp3": 11983,
	"./no/sentencememory/youth/test/S-5-Y.mp3": 66402,
	"./no/sentencememory/youth/test/S-6-Y.mp3": 8406,
	"./no/sentencememory/youth/test/S-7-Y.mp3": 7469,
	"./no/sentencememory/youth/test/S-8-Y.mp3": 91138,
	"./no/sentencememory/youth/test/S-9-Y.mp3": 40828,
	"./no/sentencememory/youth/trial/Intro-AFTER-trial.mp3": 79470,
	"./no/sentencememory/youth/trial/Intro-Y-A.mp3": 85733,
	"./no/sentencememory/youth/trial/TRIAL-1-if-correct.mp3": 50828,
	"./no/sentencememory/youth/trial/TRIAL-1-if-wrong.mp3": 10372,
	"./no/sentencememory/youth/trial/TRIAL-1.mp3": 12040,
	"./no/sentencememory/youth/trial/TRIAL-2-if-correct-kopi.mp3": 56942,
	"./no/sentencememory/youth/trial/TRIAL-2-if-wrong.mp3": 48515,
	"./no/sentencememory/youth/trial/TRIAL-2.mp3": 63514,
	"./no/sentencememory/youth/trial/Øving-1.mp3": 40723,
	"./no/spoonerism/correct-1.mp3": 30115,
	"./no/spoonerism/correct-2.mp3": 13170,
	"./no/spoonerism/correct-3.mp3": 23321,
	"./no/spoonerism/incorrect-1.mp3": 38712,
	"./no/spoonerism/incorrect-2.mp3": 36676,
	"./no/spoonerism/incorrect-3.mp3": 1286,
	"./no/spoonerism/intro-end.mp3": 25081,
	"./no/spoonerism/intro.mp3": 714,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-1.mp3": 11827,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-10.mp3": 20253,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-11.mp3": 88889,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-12.mp3": 16878,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-13.mp3": 16490,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-14.mp3": 18861,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-15.mp3": 9408,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-16.mp3": 34260,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-17.mp3": 22780,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-18.mp3": 60520,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-2.mp3": 30541,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-3.mp3": 24405,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-4.mp3": 97131,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-5.mp3": 57624,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-6.mp3": 46362,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-7.mp3": 92872,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-8.mp3": 41536,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-9.mp3": 79060,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRAIL1.mp3": 97096,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL1-if-correct.mp3": 3200,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL1-if-one-correct.mp3": 58964,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-both-wrong.mp3": 48786,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-correct.mp3": 91829,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-one-correct.mp3": 78606,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2.mp3": 47012,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3-if-both-wrong.mp3": 28510,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3-if-correct.mp3": 79101,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3-if-one-correct.mp3": 88131,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3.mp3": 29716,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro-AFTER-trail.mp3": 51992,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro.mp3": 32082,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-trial1-if-both-wrong.mp3": 23489,
	"./no/spoonerism/proveoppgave-1.mp3": 43069,
	"./no/spoonerism/proveoppgave-2.mp3": 49260,
	"./no/spoonerism/proveoppgave-3.mp3": 67240,
	"./no/spoonerism/spoonerism-task (1).mp3": 54280,
	"./no/spoonerism/spoonerism-task (10).mp3": 99710,
	"./no/spoonerism/spoonerism-task (11).mp3": 30790,
	"./no/spoonerism/spoonerism-task (12).mp3": 24976,
	"./no/spoonerism/spoonerism-task (13).mp3": 97206,
	"./no/spoonerism/spoonerism-task (14).mp3": 93380,
	"./no/spoonerism/spoonerism-task (15).mp3": 38178,
	"./no/spoonerism/spoonerism-task (16).mp3": 22319,
	"./no/spoonerism/spoonerism-task (17).mp3": 47381,
	"./no/spoonerism/spoonerism-task (18).mp3": 42587,
	"./no/spoonerism/spoonerism-task (19).mp3": 63524,
	"./no/spoonerism/spoonerism-task (2).mp3": 47953,
	"./no/spoonerism/spoonerism-task (20).mp3": 99624,
	"./no/spoonerism/spoonerism-task (3).mp3": 72914,
	"./no/spoonerism/spoonerism-task (4).mp3": 94297,
	"./no/spoonerism/spoonerism-task (5).mp3": 2742,
	"./no/spoonerism/spoonerism-task (6).mp3": 28799,
	"./no/spoonerism/spoonerism-task (7).mp3": 45527,
	"./no/spoonerism/spoonerism-task (8).mp3": 16716,
	"./no/spoonerism/spoonerism-task (9).mp3": 28222,
	"./no/workingmemory_numbers/wmTrial-numbers-1.mp3": 69091,
	"./no/workingmemory_numbers/wmTrial-numbers-2.mp3": 17112,
	"./no/workingmemory_numbers/workingmemory-numbers-1.mp3": 28835,
	"./no/workingmemory_numbers/workingmemory-numbers-10.mp3": 905,
	"./no/workingmemory_numbers/workingmemory-numbers-11.mp3": 1506,
	"./no/workingmemory_numbers/workingmemory-numbers-12.mp3": 57367,
	"./no/workingmemory_numbers/workingmemory-numbers-2.mp3": 45982,
	"./no/workingmemory_numbers/workingmemory-numbers-3.mp3": 67345,
	"./no/workingmemory_numbers/workingmemory-numbers-4.mp3": 4067,
	"./no/workingmemory_numbers/workingmemory-numbers-5.mp3": 63202,
	"./no/workingmemory_numbers/workingmemory-numbers-6.mp3": 86638,
	"./no/workingmemory_numbers/workingmemory-numbers-7.mp3": 47129,
	"./no/workingmemory_numbers/workingmemory-numbers-8.mp3": 18596,
	"./no/workingmemory_numbers/workingmemory-numbers-9.mp3": 54513,
	"./no/workingmemory_words/wmTrial-words-1.mp3": 59767,
	"./no/workingmemory_words/wmTrial-words-2.mp3": 32173,
	"./no/workingmemory_words/workingmemory-words-1.mp3": 40880,
	"./no/workingmemory_words/workingmemory-words-10.mp3": 22811,
	"./no/workingmemory_words/workingmemory-words-11.mp3": 73985,
	"./no/workingmemory_words/workingmemory-words-12.mp3": 37319,
	"./no/workingmemory_words/workingmemory-words-2.mp3": 48489,
	"./no/workingmemory_words/workingmemory-words-3.mp3": 91591,
	"./no/workingmemory_words/workingmemory-words-4.mp3": 55841,
	"./no/workingmemory_words/workingmemory-words-5.mp3": 48051,
	"./no/workingmemory_words/workingmemory-words-6.mp3": 95119,
	"./no/workingmemory_words/workingmemory-words-7.mp3": 51328,
	"./no/workingmemory_words/workingmemory-words-8.mp3": 16460,
	"./no/workingmemory_words/workingmemory-words-9.mp3": 63842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91561;